









































import { Component, Vue, Prop } from 'vue-property-decorator'
import PhotoHeader from '../components/organization/PhotoHeader.vue'
import Main from '../components/organization/Main.vue'
import MiniCourse from '../components/miniCourse/index.vue'
import { miniCourses_Section } from '@/models/miniCourses'

@Component({
  components: {
    PhotoHeader,
    Main,
    MiniCourse
  }
})
export default class MiniCourses extends Vue {
  private coursesList: any
  private filtered_courses: any

  private title = 'Minicursos'
  private description = 'Minicursos da jornada'
  private background = 'assets/img/lab.jpg'

  filterCourses(e: any) {
    let data = e.target.innerText
    this.filtered_courses = this.coursesList.map(item => {
      const minicurso = item.minicurso.filter(aux => {
        return aux.date == data
      })

      return { ...item, minicurso }
    })
  }

  clearFilter() {
    this.filtered_courses = this.coursesList
  }

  constructor() {
    super()

    this.coursesList = miniCourses_Section
    this.filtered_courses = this.coursesList
  }
}
